import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import DespesaIcon from "../../assets/icons/despesas.png";

import DespesasService from "../../services/DespesasService";
import DespesasItensService from "../../services/DespesasItensService";

export default function DespesaForm({ itemSelecionado, modo, onClose }) {
  const { setRetorno } = useGerenciamento();

  const [form, setForm] = useState({
    idDespesa: null,
    idCadastro: "",
    repetirMeses: 1,
    observacao: ""
  });

  const [itens, setItens] = useState([]);
  const [listaItens, setListaItens] = useState([]);
  const [itensDespesas, setItensDespesas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // ==========================
  // LOAD BASE ITENS
  // ==========================
  useEffect(() => {
    async function carregarItens() {
      const itensAtivos = await DespesasItensService.getAtivas();
      setItensDespesas(itensAtivos || []);
    }
    carregarItens();
  }, []);

  // ==========================
  // LOAD ALTERAR
  // ==========================
  useEffect(() => {
    if (modo === "alterar" && itemSelecionado) {

      setForm({
        idDespesa: itemSelecionado.IDDESPESA,
        observacao: itemSelecionado.OBSERVACAO ?? ""
      });

      setListaItens([
        {
          IDDESPESA: itemSelecionado.IDDESPESA,
          IDITEMDESPESA: itemSelecionado.IDITEMDESPESA,
          valor: Number(itemSelecionado.valor),
          DATA_VENCIMENTO: itemSelecionado.DATA_VENCIMENTO,
          PAGO: Boolean(itemSelecionado.PAGO),
          ATIVO: Boolean(itemSelecionado.ATIVO)
        }
      ]);
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function handleItemChange(index, campo, valor) {
    const novos = [...listaItens];
    novos[index][campo] = valor;

    if (campo === "valor") {
      novos[index].valor = Number(valor);
    }

    setListaItens(novos);
  }


  function adicionarItem() {
    setListaItens([
      ...listaItens,
      {
        IDITEMDESPESA: "",
        valor: 0,
        competencia: "",
        PAGO: false
      }
    ]);
  }

  function removerItem(index) {
    setListaItens(listaItens.filter((_, i) => i !== index));
  }

  function handleCompetenciaChange(index, value) {
    // Remove tudo que não for número
    let v = value.replace(/\D/g, "");

    // Limita a 4 dígitos (MMYY)
    if (v.length > 4) v = v.slice(0, 4);

    // Adiciona barra automática
    if (v.length > 2) {
      v = v.slice(0, 2) + "/" + v.slice(2);
    }

    const novos = [...listaItens];
    novos[index].competencia = v;
    setListaItens(novos);
  }

  // ==========================
  // VALIDAR
  // ==========================
  function validar() {
    const e = {};
    if (!listaItens.length) e.itens = "Adicione pelo menos um item";
    listaItens.forEach((i, idx) => {
      if (!i.IDITEMDESPESA) e[`item_${idx}`] = "Informe item";
      if (!i.valor) e[`valor_${idx}`] = "Informe valor";
      if (!i.DATA_VENCIMENTO) e[`vencimento_${idx}`] = "Informe data de vencimento";
    });
    return e;
  }

  // ==========================
  // TOTAL
  // ==========================
  const valorTotal = listaItens.reduce((t, i) => t + Number(i.valor || 0), 0);

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();
    const validation = validar();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {

      const payload = {
        IDDESPESA: form.idDespesa,
        IDITEMDESPESA: Number(listaItens[0].IDITEMDESPESA),
        valor: Number(listaItens[0].valor),
        DATA_VENCIMENTO: listaItens[0].DATA_VENCIMENTO,
        OBSERVACAO: form.observacao,
        PAGO: listaItens[0].PAGO,
        ATIVO: listaItens[0].ATIVO
      };
    
      if (modo === "novo") {
        await DespesasService.create([payload]);
    
        setRetorno({
          tipo: "sucesso",
          mensagem: "Despesa lançada com sucesso!"
        });
      }
    
      if (modo === "alterar") {
        await DespesasService.update(form.idDespesa, payload);
    
        setRetorno({
          tipo: "sucesso",
          mensagem: "Despesa atualizada com sucesso!"
        });
      }
    
      onClose();
    
    } catch {
    
      setRetorno({
        tipo: "erro",
        mensagem: "Erro ao salvar despesas."
      });
    
      onClose();
    
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={DespesaIcon} alt="" className="icon" />
          {modo === "novo" ? "Nova Despesa" : "Alterar Despesa"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-label">Itens do mês</div><br/>

        <div className="label-itens">
          <div className="select-itens">Descrição </div> |
          <div className="input-itens">Valor</div> |
          <div className="input-itens">Venc.</div> |
          <div className="input-itens">Pago.</div> 
        </div>

        {listaItens.map((item, index) => (
          <div key={index} className="Form-Interno-alinhamento-itens">
            <select
              className="select-itens"
              value={item.IDITEMDESPESA}
              onChange={e => handleItemChange(index, "IDITEMDESPESA", e.target.value)}
            >
              <option value="" >Selecione Item</option>
              {itensDespesas.map(i => (
                <option key={i.IDITEMDESPESA} value={i.IDITEMDESPESA}>
                  {i.DESCRICAO}
                </option>
              ))}
            </select>

            <input
              type="number"
              className="input-itens"
              title="Valor"
              value={item.valor}
              onChange={e => handleItemChange(index, "valor", e.target.value)}
              placeholder="Valor"
            />

            <input
              type="date"
              className="input-itens"
              title="Vencimento"
              value={item.DATA_VENCIMENTO || ""}
              onChange={e => handleItemChange(index, "DATA_VENCIMENTO", e.target.value)}
            />

            <select
              className="select-itens"
              value={String(item.PAGO)}
              onChange={e => handleItemChange(index, "PAGO", e.target.value === "true")}
            >
              <option selected value="">Selecione</option>
              <option value={true}>Pago</option>
              <option value={false}>Pendente</option>
            </select>

            <button type="button" title="Remover o Item selecionado" onClick={() => removerItem(index)}>
              X
            </button>
          </div>
        ))}

        <div className="Form-Interno-alinhamento-button">
          <button type="button" onClick={adicionarItem}>
            + Item
          </button>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">
            Total: R$ {valorTotal.toFixed(2)}
          </div>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observação</div>
          <input
            name="observacao"
            value={form.observacao}
            onChange={handleChange}
          />
        </div>

        {modo === "alterar" && (
            <div className="Form-Interno-alinhamento">
              <div className="Form-Interno-label">Ativo</div>

              <select
                value={String(listaItens[0]?.ATIVO)}
                onChange={e =>
                  handleItemChange(0, "ATIVO", e.target.value === "true")
                }
              >
                <option value={true}>Sim</option>
                <option value={false}>Não</option>
              </select>
            </div>
          )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Salvando..." : "Salvar"}
          </button>
          
          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}